$(document).ready(function () {
	$('.accordion-heading').on('click', function () {
	  const $this = $(this);
	  const accordionId = $this.data('accordion');
	  const $content = $('#' + accordionId);

	
	  if ($this.hasClass('active')) {
		
		$this.removeClass('active');
		$content.slideUp(250);
	  } else {
		
		$('.accordion-heading').removeClass('active');
		$('.accordion-content').slideUp(250);

		
		$this.addClass('active');
		$content.slideDown(250);
	  }
	});
  });